import React from 'react'
import { Social, TitleSocial, SocialIcon } from './index.styled'

const SocialIcons = ({ className }) => {
  return (
    <Social className={className}>
      <TitleSocial>FOLLOW US</TitleSocial>
      <SocialIcon
        href='/'
        target='_blank'
        rel='noreferrer'
        className='instagram'
      />
      <SocialIcon href='/' target='_blank' rel='noreferrer' className='fb' />
      <SocialIcon
        href='/'
        target='_blank'
        rel='noreferrer'
        className='youtube'
      />
      <SocialIcon href='/' target='_blank' rel='noreferrer' className='x' />
      <SocialIcon href='/' target='_blank' rel='noreferrer' className='in' />
    </Social>
  )
}

export default SocialIcons
